import { render, staticRenderFns } from "./JEditableTable.vue?vue&type=template&id=2c2cfd3f&scoped=true&"
import script from "./JEditableTable.vue?vue&type=script&lang=js&"
export * from "./JEditableTable.vue?vue&type=script&lang=js&"
import style0 from "./JEditableTable.vue?vue&type=style&index=0&id=2c2cfd3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2cfd3f",
  null
  
)

export default component.exports